// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

/**
 * Items with access permission for the application
 */
export enum PermissionItem {
  CONTACT = 1,
  ACCOUNT = 2,
  BUSINESS = 3,
  LEAD = 4,
  TODO = 5,
  APPOINTMENT = 6,
  NEWS = 7,
  MINUTES = 8,
  REPORTING = 9,
  TARGET = 10,
  ADMIN_PRODUCT = 11,
  ADMIN_REFERENCEDATA = 12,
  ADMIN_CUSTOMFIELD = 13,
  ADMIN_ROLEPERMISSION = 14,
  ADMIN_SALESTEAM = 15,
  ADMIN_USERROLES = 16,
  ADMIN_PORTFOLIO = 17,
  REPORTING_REPORT = 18,
  SEGMENTATION = 19,
  ADMIN_UTILITIES = 20,
  CAMPAIGN = 21,
  ADMIN_TENANT = 22,
  REPORTING_USAGE = 23,
  REPORTING_PERFORMANCEREVIEW = 24,
  ADMIN_NEWS = 25,
  RECYCLEBIN = 26,
  DOCUMENT = 27,
  PERSONALACCESSTOKEN = 28,
  WORKFLOW = 29,
  TICKET = 30,
  ACCOUNT_CUSTOMER = 31,
  ACCOUNT_PROSPECT = 32,
  ACCOUNT_OTHER = 33,
  PROJECT = 35,
}

/**
 * Actions allowed on the items
 */
export enum PermissionAction {
  NONE = 0,
  READ = 1,
  CREATE = 2,
  UPDATE = 4,
  DELETE = 8,
  BULK_UPDATE = 16,
  BULK_DELETE = 32,
}

/**
 * List of options to select permissions
 */
export enum PermissionOption {
  READ = 1,
  READ_CREATE = 3,
  READ_UPDATE = 5,
  READ_CREATE_UPDATE = 7,
  READ_CREATE_UPDATE_DELETE = 15,
  ALL = 63,
}

/**
 * Action scopes
 */
export enum PermissionScope {
  GLOBAL = 0,
  RESTRICTED = 1,
}
